import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyReview = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }
    axios
      .post(`${API}/reviews/verify`, { token })
      .then((res) => {
        setStatus('success');
        setMessage(res.data?.message || 'Your review has been confirmed.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Could not verify this review. The link may have expired.');
      });
  }, [token]);

  return (
    <div className="min-h-[60vh] bg-neutral-50 flex items-center justify-center px-4 py-16">
      <div className="bg-white rounded-2xl border border-neutral-200 p-8 max-w-md w-full text-center" data-testid="verify-review-page">
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
            <h1 className="text-xl font-bold text-neutral-900">Confirming your review...</h1>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-9 h-9 text-green-600" />
            </div>
            <h1 className="text-2xl font-bold text-neutral-900 mb-2">Review Confirmed!</h1>
            <p className="text-neutral-600 mb-6">{message}</p>
            <p className="text-sm text-neutral-500 mb-6">
              Our team will review your post and approve it shortly. Thanks for supporting local businesses!
            </p>
            <Link to="/businesses" className="btn-primary">
              Browse More Businesses
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-9 h-9 text-red-600" />
            </div>
            <h1 className="text-2xl font-bold text-neutral-900 mb-2">Verification Failed</h1>
            <p className="text-neutral-600 mb-6">{message}</p>
            <Link to="/" className="btn-primary">
              Back to Home
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyReview;
